import type { QueryClient } from "@tanstack/react-query";

/** React Query key scoped to the signed-in user so explorer data cannot leak across accounts. */
export function explorerOnboardingQueryKey(objectId: string | null | undefined) {
  return ["explorer-onboarding-me", objectId ?? ""] as const;
}

export function isUserDoesNotExistError(err: unknown): boolean {
  const msg =
    (err as { response?: { data?: { message?: string } | string } })?.response
      ?.data;
  const message =
    typeof msg === "string" ? msg : (msg as { message?: string } | undefined)?.message;
  return (
    message === "User does not exist" ||
    (typeof message === "string" && message.includes("User does not exist"))
  );
}

/** Drop cached user/explorer rows when the active account changes (login, logout, verify). */
export function clearAuthSensitiveQueries(queryClient: QueryClient): void {
  queryClient.removeQueries({ queryKey: ["explorer-onboarding-me"] });
  queryClient.removeQueries({ queryKey: ["user"] });
}
